import { callFunction } from './callableClient'
import type { Partner } from '../types/partner'

type GetCurrentPartnerResponse = {
  partner: Partner | null
}

export async function getCurrentPartner(): Promise<Partner | null> {
  const result = await callFunction<undefined, GetCurrentPartnerResponse>(
    'partnerGetCurrentPartner'
  )
  return result.partner
}
